import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as SearchActions from './actions';

import SearchPage from './SearchPage';

const SearchPageContainer = ({
  dispatch,
  contracts
}) => {
  const drizzle = useDrizzleContext();
  const contract = drizzle.contracts.THDJabraToken;

  const [ dataKey, setDataKey ] = useState("");
  const [ jabraTokens, setJabraTokens ] = useState([]);
  const [ data, setData ] = useState({ addressOfOwner: "" });
  
  const TIME_BIN = 30 * 60;

  useEffect(() => {
    setJabraTokens(fetchTokens(dataKey));
  }, [contracts, dataKey]);

  const handleChange = e => {
    setData({...data, [e.target.name]: e.target.value});
  };

  const handleSubmit = e => {
    e.preventDefault();
    showTokens(contract, data.addressOfOwner);
    e.target.reset();
  };

  const handleClear = e => {
    e.preventDefault();
    setDataKey(0);
  };

  const showTokens = async (contract, address) => {
    //jabraTokens = []; // Instead of this, the list isn't displayed.  Why? I don't understand why somtimes rendered and sometimes not rendered.

    var _dataKey = address !== "0x0" && address !== ""
      ? await contract.methods.showJabrasByReservedTime.cacheCall(address)
      : 0;

    if (_dataKey === null)
      _dataKey = 0;

    setDataKey(_dataKey);
    //setJabraTokens(fetchTokens(_dataKey)); // This is also needed to display the list?
  }

  const fetchTokens = _dataKey => {
    var jabraTokensString = [];
    var middleStateTokens = [];
    var tokenId;
    var reserveTime;
    var reservedTime;
    const reserveTimeShift = 8;

    jabraTokensString = contracts.THDJabraToken.showJabrasByReservedTime[_dataKey]
      ? contracts.THDJabraToken.showJabrasByReservedTime[_dataKey].value
      : [];

    if (jabraTokensString !== undefined && jabraTokensString !== null) {
      for (var i = 0; i < jabraTokensString.length; i++) {
        tokenId = parseInt(jabraTokensString[i].tokenId);
        reserveTime = (tokenId - (tokenId % (2 ** reserveTimeShift)))/ (2 ** reserveTimeShift); // Note that unsigned right shift >>> doesn't work well because of the limit of integers.
        reservedTime = parseInt(jabraTokensString[i].reservedTime);
        middleStateTokens[i] = {
          tokenId: tokenId,
          reserveTime: reserveTime,
          reservedTime: reservedTime,
          next: jabraTokensString[i].next
        };
      }
    }
    const result = calculateTimeRange(middleStateTokens);
    if (result !== [])
      dispatch(fetchedJabraTokens())

    return result;
  }

  const calculateTimeRange = middleStateTokens => {
    var calculated = [];
    var startTime = -1;
    var endTime = -1;

    const sorted = middleStateTokens.slice().sort((a, b) => { // FIXME Is this array really copied and remain unchanged?
      if (a.reserveTime > b.reserveTime)
        return 1;
      else
        return -1;
    });

    var j = 0;
    for (var i = 0; i < sorted.length; i++) {
      startTime = sorted[i].reserveTime;
      endTime = startTime + TIME_BIN;

      if (!sorted[i].next) {
        if (i === 0 || !sorted[i-1].next) {
          calculated[j] = {
            tokenId: sorted[i].tokenId,
            startTime: startTime,
            endTime: endTime,
            reservedTime: sorted[i].reservedTime
          };
          j++;
        } else {
          calculated[j] = {
            tokenId: calculated[j].tokenId,
            startTime: calculated[j].startTime,
            endTime: endTime,
            reservedTime: calculated[j].reservedTime
          };
          j++;
        }
      } else {
        if (i === 0 || !sorted[i-1].next) {
          calculated[j] = {
            tokenId: sorted[i].tokenId,
            startTime: startTime,
            reservedTime: sorted[i].reservedTime
          };
        }
      }
    }
    return calculated;
  }

  return (
    <SearchPage
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleClear={handleClear}
      jabraTokens={jabraTokens}
    />
  );
}

const fetchedJabraTokens = () => {
  return {
    type: SearchActions.FETCHED_JABRATOKENS
  }
}

const mapStateToProps = state => {
  return {
    contracts: state.contracts,
  };
};

export default connect(mapStateToProps)(SearchPageContainer);
